import { Level } from 'ng2-logger/browser';

export const environment = {
    production: true,

    froala: '6LF5g1D4A2H3B6B4B3F-11SLJCKHXOSLMc1YGSGb1ZXHSe1CgB5A4D4B3E3C2A14A19A6B6==',
    userlane: '7lewl',
    appVersion: '50157',

    api: {
        baseUrl: 'https://invitedeskapi-dev.azurewebsites.net',
        prefix: '/api'
    },

    scheduling: {
        baseUrl: 'https://wa-ivd-scheduling-api-dev.azurewebsites.net',
        prefix: '/api'
    },

    dashboardApi: {
      baseUrl: 'https://wa-ivd-dashboard-api-dev.azurewebsites.net',
      prefix: '/api/dashboard/'
    },

    frontdesk: {
        baseUrl: 'https://invitedeskfrontdeskdev.azurewebsites.net',
    },

    engage: {
        baseUrl: 'https://events.dev.invitedesk.com'
    },

    halitoApi: {
        baseUrl: 'https://api.k8s.dev.halito.com'
    },

    publicregistration: {
        baseUrl: 'https://invitedeskpublicregdev.azurewebsites.net',
    },

    sync: {
        baseUrl: 'https://wa-frontend-d-invitedesk.azurewebsites.net',
    },

    identityServer: {
        baseUrl: 'https://wa-ivd-identityserver-dev.azurewebsites.net'
    },

    signalrService: {
        jobsHubUrl: 'https://fa-ivd-jobs-dev.azurewebsites.net/api/signalr',
        connectorHubUrl: 'https://fa-d-invitedesk.azurewebsites.net/api/signalr/connector'
    },

    logger: {
        default: {
            levels: [
                Level.ERROR,
                Level.WARN,
                Level.INFO,
                /* , Level.DATA */
            ]
        },
        sinks: {
            application: {
                name: 'application',
                levels: [
                    Level.ERROR,
                    Level.WARN,
                    Level.INFO,
                    /* , Level.DATA */
                ]
            },
            auth: {
                name: 'auth',
                levels: [
                    Level.ERROR,
                    Level.WARN,
                    Level.INFO,
                    Level.DATA
                ]
            },
            http: {
                name: 'http',
                levels: [
                    Level.ERROR,
                    Level.WARN,
                    Level.INFO,
                    /*Level.DATA*/
                ]
            },
            router: {
                name: 'router',
                levels: [
                    Level.ERROR,
                    Level.WARN,
                    /*Level.INFO,*/
                    /*Level.DATA*/
                ]
            },
            store: {
                name: 'store',
                levels: [
                    Level.ERROR,
                    Level.WARN,
                    Level.INFO,
                    /*Level.DATA*/
                ]
            },
        }
    },

    firebaseConfig: {
      apiKey: 'AIzaSyC9EKPMcGb3MbgNBO7LYQVUbgWtPwA07NQ',
      authDomain: 'invitedesk-notifications-dev.firebaseapp.com',
      projectId: 'invitedesk-notifications-dev',
      storageBucket: 'invitedesk-notifications-dev.appspot.com',
      messagingSenderId: '807746311735',
      appId: '1:807746311735:web:e9b65b1e3eb7b6800f11b2',
      vapidKey: 'BNc9w9FRDUYoc54kw_ftCoPxFQLCpHBs1WYLohu3bXao1M_3th-vvcjOkZl9A0tbHyPiM3wwysv7GtfUgWJTy04'
    }

};
